<template>
    <v-card class="ma-3 ">
        <v-form ref="form" v-model="valid" style="width: 100%" @submit.prevent="save">
            <v-row>
                <v-col class="d-flex" cols="12">
                    <v-card style="width: 100%">
                        <v-card-text>
                            <v-text-field v-model="form.name" label="模板名称 *" :rules="[(v) => !!v || '模板名称不能为空']">
                            </v-text-field>
                            <v-text-field v-model="form.template_code" label="模板代码 *" :rules="[(v) => !!v || '模板名称不能为空']">
                            </v-text-field>
                            <v-select v-model="form.template_type" :items="typeList" item-text="name" item-value="value"
                                label="模板类型 *" :rules="[(v) => !!v || '移动模式不能为空']"></v-select>
                            <v-text-field v-model="form.belongTo_code" label="同一所属代码"></v-text-field>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="d-flex" cols="6">
                    <v-card class="card-content">
                        <v-card-title> 添加动态模板操作 </v-card-title>

                        <v-card-actions class="d-flex flex-wrap">
                            <v-col cols="12" class="py-2">
                                <!-- <p>Text Options</p> -->

                                <v-btn-toggle tile color="#057dd3" group dense class="d-flex flex-wrap">
                                    <v-btn depressed @click="addTextField">
                                        新增文本输入框
                                    </v-btn>
                                    <v-btn @click="addTextareas">
                                        新增多行文本框
                                    </v-btn>
                                    <v-btn @click="addRadio"> 新增单选框 </v-btn>
                                    <v-btn @click="addSelects"> 新增下拉框 </v-btn>
                                    <v-btn @click="addSwitches"> 新增开关 </v-btn>
                                    <v-btn @click="addZb"> 新增坐标系 </v-btn>
                                    <v-btn @click="addCascader">
                                        新增级联选择器
                                    </v-btn>
                                    <v-btn @click="addTable"> 新增表格 </v-btn>
                                </v-btn-toggle>
                            </v-col>
                        </v-card-actions>
                        <v-card-text>
                            <v-list>
                                <v-list-group v-for="(item, index) in items" :key="index" no-action>
                                    <!-- <p>{{item}}</p> -->
                                    <template #activator>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="
                                                    item.Fields[0].Label ||
                                                    item.name
                                                "></v-list-item-title>
                                        </v-list-item-content>
                                        <v-btn :disabled="index === items.length - 1" icon color="rgb(5, 125, 211)"
                                            @click.stop="move(item, index, 'down')">
                                            <v-icon>mdi-arrow-collapse-down</v-icon>
                                        </v-btn>
                                        <v-btn :disabled="index === 0" icon color="rgb(5, 125, 211)"
                                            @click.stop="move(item, index, 'up')">
                                            <v-icon>mdi-arrow-collapse-up</v-icon>
                                        </v-btn>
                                        <v-btn icon color="red" @click.stop="delFields(index)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list-item v-for="(child, index2) in item.Fields" :key="index2">
                                        <!-- 新增文本域 -->
                                        <v-list-item-content v-if="item.Type === 'TextField'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.DefaultVal" label="定义默认值"></v-text-field>
                                                <v-text-field v-model="child.cols" type="number" label="设置cols">
                                                </v-text-field>
                                                <v-select v-model="child.InputType" :items="myInputTypeOptions"
                                                    item-text="name" item-value="value" label="选择文本类型"></v-select>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增多行文本框 -->
                                        <v-list-item-content v-if="item.Type === 'Textareas'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.DefaultVal" label="定义默认值"></v-text-field>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增下拉框 -->
                                        <v-list-item-content v-if="item.Type === 'Selects'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-select v-model="child.DefaultVal" :items="child.Options" item-text="name"
                                                    item-value="value" label="添加配置项并设置默认值" append-outer-icon="mdi-plus"
                                                    @click:append-outer="
                                                        addOptions(
                                                            child,
                                                            index,
                                                            index2
                                                        )
                                                    "></v-select>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增单选框 -->
                                        <v-list-item-content v-if="item.Type === 'Radio'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-select v-model="child.DefaultVal" :items="child.Options" item-text="name"
                                                    item-value="value" label="添加配置项并设置默认值" append-outer-icon="mdi-plus"
                                                    @click:append-outer="
                                                        addOptions(
                                                            child,
                                                            index,
                                                            index2
                                                        )
                                                    "></v-select>
                                                <v-switch v-model="child.isColumn" label="是否列显示" color="red darken-3">
                                                </v-switch>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增开关 -->
                                        <v-list-item-content v-if="item.Type === 'Switches'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <!-- <v-text-field
                                                    v-model="child.DefaultVal"
                                                    label="定义默认值"
                                                ></v-text-field> -->
                                                <v-switch v-model="child.DefaultVal" label="定义默认值" color="red darken-3"
                                                    class="d-inline-flex"></v-switch>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增坐标系 -->
                                        <v-list-item-content v-if="item.Type === 'Zb'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]" @input="
                                                        changeZbCode(child, $event)
                                                    "></v-text-field>
                                                <v-text-field v-model="child.XDefaultVal" label="定义X默认值"></v-text-field>
                                                <v-text-field v-model="child.YDefaultVal" label="定义Y默认值"></v-text-field>
                                                <v-text-field v-model="child.ZDefaultVal" label="定义Z默认值"></v-text-field>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增级联选择器 -->
                                        <v-list-item-content v-if="item.Type === 'Cascader'"
                                            class="d-flex align-start flex-column px-3">
                                            <!-- 1级 -->
                                            <div v-if="child.Level === 1" style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.cols" type="number" label="设置cols">
                                                </v-text-field>
                                                <v-select v-model="child.DefaultVal" :items="child.Options" item-text="name"
                                                    item-value="value" label="添加配置项并设置默认值" append-outer-icon="mdi-plus"
                                                    @click:append-outer="
                                                        addOptions(
                                                            child,
                                                            index,
                                                            index2
                                                        )
                                                    " @change="
                                                        changeCascader(
                                                            item,
                                                            index2,
                                                            $event
                                                        )
                                                    "></v-select>
                                                <div class="optionsBtn">
                                                    <a v-if="
                                                            index2 ===
                                                            item.Fields.length - 1
                                                        " href="javascript:;" @click="
                                                            addSubLevel(
                                                                child,
                                                                index
                                                            )
                                                        "><span>添加子级</span></a>
                                                </div>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                            <!-- 其他级 -->
                                            <div v-if="child.Level !== 1" style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.cols" type="number" label="设置cols">
                                                </v-text-field>
                                                <v-select v-model="child.DefaultVal" :items="child.currOptions"
                                                    item-text="name" item-value="value" label="添加配置项并设置默认值"
                                                    append-outer-icon="mdi-plus" @click:append-outer="
                                                        addOptions(
                                                            child,
                                                            index,
                                                            index2
                                                        )
                                                    " @change="
                                                        changeCascader(
                                                            item,
                                                            index2,
                                                            $event
                                                        )
                                                    "></v-select>
                                                <div class="optionsBtn">
                                                    <a v-if="
                                                            index2 ===
                                                            item.Fields.length - 1
                                                        " href="javascript:;" @click="
                                                            addSubLevel(
                                                                child,
                                                                index
                                                            )
                                                        "><span>添加子级</span></a>
                                                    <a v-if="
                                                            index2 ===
                                                            item.Fields.length - 1
                                                        " class="removeSubLevel" href="javascript:;" @click="
                                                            removeSubLevel(
                                                                index,
                                                                index2
                                                            )
                                                        "><span>删除子级</span></a>
                                                </div>
                                                <v-switch v-model="child.FieldRequired" label="是否必填" color="red darken-3">
                                                </v-switch>
                                            </div>
                                        </v-list-item-content>
                                        <!-- 新增表格 -->
                                        <v-list-item-content v-if="item.Type === 'Table'"
                                            class="d-flex align-start flex-column px-3">
                                            <div style="width: 100%">
                                                <v-text-field v-model="child.Label" label="定义名称 *" :rules="[
                                                        (v) =>
                                                            !!v || '名称不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.Code" label="定义字段代码 *" :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            '字段代码不能为空',
                                                    ]"></v-text-field>
                                                <v-text-field v-model="child.cols" type="number" label="设置cols">
                                                </v-text-field>
                                                <v-select :items="child.Options" item-text="text" item-value="value"
                                                    label="设置表格头部项" append-outer-icon="mdi-plus" @click:append-outer="
                                                        addTableOptions(
                                                            child,
                                                            index
                                                        )
                                                    "></v-select>
                                                <div>
                                                    <p>选择按钮权限</p>
                                                    <v-checkbox v-model="child.btns" label="新增" value="add" hide-details>
                                                    </v-checkbox>
                                                    <!-- <v-checkbox
                                                        v-model="child.btns"
                                                        label="编辑"
                                                        value="update"
                                                        hide-details
                                                    ></v-checkbox> -->
                                                    <v-checkbox v-model="child.btns" label="删除" value="del" hide-details>
                                                    </v-checkbox>
                                                </div>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="d-flex" cols="6">
                    <v-card class="card-content">
                        <v-card-title> 动态模板预览 </v-card-title>
                        <v-card-text>
                            <v-form>
                                <v-row>
                                    <v-col v-for="(item, index) in items" :key="index" class="d-flex" :cols="
                                            item.Fields[0].cols
                                                ? item.Fields[0].cols
                                                : '12'
                                        ">
                                        <v-text-field v-if="item.Type === 'TextField'" v-model="item.Fields[0].DefaultVal"
                                            :type="item.Fields[0].InputType" :label="item.Fields[0].Label" :rules="[
                                                item.Fields[0].FieldRequired
                                                    ? (v) => !!v || '请填写'
                                                    : false,
                                            ]"></v-text-field>
                                        <v-textarea v-if="item.Type === 'Textareas'" v-model="item.Fields[0].DefaultVal"
                                            :label="item.Fields[0].Label" auto-grow :rules="[
                                                item.Fields[0].FieldRequired
                                                    ? (v) => !!v || '请填写'
                                                    : false,
                                            ]"></v-textarea>
                                        <v-select v-if="item.Type === 'Selects'" v-model="item.Fields[0].DefaultVal"
                                            :items="item.Fields[0].Options" item-text="name" item-value="value"
                                            :label="item.Fields[0].Label" :rules="[
                                                item.Fields[0].FieldRequired
                                                    ? (v) => !!v || '请选择'
                                                    : false,
                                            ]"></v-select>
                                        <div v-if="item.Type === 'Radio'" class="d-flex align-center">
                                            <span v-if="item.Fields[0].Label" class="text-md">{{ item.Fields[0].Label
                                                }}：</span>
                                            <v-radio-group v-model="item.Fields[0].DefaultVal"
                                                :row="!item.Fields[0].isColumn" :column="item.Fields[0].isColumn"
                                                :mandatory="
                                                    item.Fields[0].FieldRequired
                                                ">
                                                <v-radio v-for="o in item.Fields[0]
                                                        .Options" :key="o.value" :label="o.name" :value="o.value">
                                                </v-radio>
                                            </v-radio-group>
                                        </div>
                                        <v-switch v-if="item.Type === 'Switches'" v-model="item.Fields[0].DefaultVal"
                                            :label="item.Fields[0].Label" color="red darken-3" class="d-inline-flex">
                                        </v-switch>
                                        <div v-if="item.Type === 'Zb'" class="d-flex align-center">
                                            <span v-if="item.Fields[0].Label" class="text-md">{{ item.Fields[0].Label
                                                }}：</span>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="
                                                            item.Fields[0]
                                                                .XDefaultVal
                                                        " label="X" :rules="[
                                                            item.Fields[0]
                                                                .FieldRequired
                                                                ? (v) =>
                                                                    !!v ||
                                                                    '请填写'
                                                                : false,
                                                        ]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="
                                                            item.Fields[0]
                                                                .YDefaultVal
                                                        " label="Y" :rules="[
                                                            item.Fields[0]
                                                                .FieldRequired
                                                                ? (v) =>
                                                                    !!v ||
                                                                    '请填写'
                                                                : false,
                                                        ]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="
                                                            item.Fields[0]
                                                                .ZDefaultVal
                                                        " label="Z" :rules="[
                                                            item.Fields[0]
                                                                .FieldRequired
                                                                ? (v) =>
                                                                    !!v ||
                                                                    '请填写'
                                                                : false,
                                                        ]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <!-- 级联预览 -->
                                        <v-row v-if="item.Type === 'Cascader'">
                                            <v-col v-for="(
                                                    option, index2
                                                ) in item.Fields" :key="index2" class="d-flex" :cols="
                                                    option.cols ? option.cols : '12'
                                                ">
                                                <v-select v-if="option.Level === 1" v-model="option.DefaultVal"
                                                    :items="option.Options" item-text="name" item-value="value"
                                                    :label="option.Label" :rules="[
                                                        option.FieldRequired
                                                            ? (v) => !!v || '请选择'
                                                            : false,
                                                    ]" @change="
                                                        changeCascader(
                                                            item,
                                                            index2,
                                                            $event
                                                        )
                                                    "></v-select>
                                                <v-select v-if="option.Level !== 1" v-model="option.DefaultVal"
                                                    :items="option.currOptions" item-text="name" item-value="value"
                                                    :label="option.Label" :rules="[
                                                        option.FieldRequired
                                                            ? (v) => !!v || '请选择'
                                                            : false,
                                                    ]" @change="
                                                        changeCascader(
                                                            item,
                                                            index2,
                                                            $event
                                                        )
                                                    "></v-select>
                                            </v-col>
                                        </v-row>
                                        <!-- 表格预览 -->
                                        <div v-if="item.Type === 'Table'" class="tableCol">
                                            <label style="width: 138px">
                                                {{ item.Fields[0].Label }}
                                            </label>
                                            <v-data-table :headers="item.Fields[0].Options"
                                                :items="item.Fields[0].DefaultVal" hide-default-footer>
                                                <template v-slot:top v-if="item.Fields[0].btns.includes('add')">
                                                    <v-btn tile small color="green">
                                                        <v-icon left>
                                                            mdi-plus</v-icon>
                                                        新增
                                                    </v-btn>
                                                </template>
                                                <template v-slot:item.option="{ item }"
                                                    v-if="item.Fields[0].btns.includes('del')">
                                                    <md-button class="md-just-icon md-danger md-round md-simple">
                                                        <md-icon>close</md-icon>
                                                    </md-button>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-card style="width: 100%">
                    <md-card-actions md-alignment="right">
                        <md-button class="md-success md-sm" type="submit" @click="save">确定</md-button>
                        <md-button class="md-success md-sm" @click="toFormwork">返回</md-button>
                    </md-card-actions>
                </v-card>
                <add-options-form :options-dialog.sync="optionsDialog"
                    :my-options-items="JSON.parse(JSON.stringify(myOptionsItems))" :parent-options="parentOptions"
                    @saveOptions="saveOptions">
                </add-options-form>
                <add-table-header :options-dialog.sync="tableOptionsDialog"
                    :options="JSON.parse(JSON.stringify(tableOptionsItems))" @saveTableOptions="saveTableOptions">
                </add-table-header>
            </v-row>
        </v-form>
    </v-card>
</template>
<script>
    import { addAction, updateAction } from '@/api/user';
    export default {
        data: () => {
            return {
                form: {
                    template_code: "",
                    name: "",
                    template_type: "",
                    belongTo_code: "",

                },
                valid: false,
                typeList: [
                    {
                        name: '场景',
                        value: 'scene',
                    },
                    {
                        name: '角色',
                        value: 'role',
                    },
                    {
                        name: '工具',
                        value: 'tool',
                    },
                    {
                        name: '设备',
                        value: 'device',
                    },
                ],
                items: [],
                // 单选自定义配置项
                myOptionsItems: {},
                // table配置项
                tableOptionsItems: [],
                // 父选项
                parentOptions: [],
                // 文本框类型配置项
                myInputTypeOptions: [],
                optionsDialog: false,
                tableOptionsDialog: false,
                // 当前操作的列下标
                currIndex: 0,
                currIndex2: 0,
            }
        },
        mounted () {
            this.init();
            // if (this.$route.params && this.$route.params._id) {
            //     this.form = this.$route.params
            //     this.items = JSON.parse(this.form.config)
            // }
            this.myInputTypeOptions = [
                {
                    name: 'Text',
                    value: 'text',
                },
                {
                    name: 'Number',
                    value: 'number',
                },
                {
                    name: 'Email',
                    value: 'email',
                },
                {
                    name: 'Password',
                    value: 'password',
                },
            ]
        },
        methods: {
            async init () {
                if (this.$route.query && this.$route.query._id) this.form = this.$route.query;
                this.items = JSON.parse(this.form.config)
            },
           
            /**
             * 新增文本输入框
             */
            addTextField () {
                let arr = {
                    name: '文本输入框',
                    Type: 'TextField',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            FieldRequired: true,
                            DefaultVal: '',
                            InputType: 'text',
                            cols: '12',
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增多行文本框
             */
            addTextareas () {
                let arr = {
                    name: '多行文本框',
                    Type: 'Textareas',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            FieldRequired: true,
                            DefaultVal: '',
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增下拉框
             */
            addSelects () {
                let arr = {
                    name: '下拉框',
                    Type: 'Selects',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            FieldRequired: true,
                            DefaultVal: '',
                            Options: [],
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增单选框
             */
            addRadio () {
                let arr = {
                    name: '单选框',
                    Type: 'Radio',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            FieldRequired: true,
                            DefaultVal: '',
                            Options: [],
                            isColumn: false,
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增开关
             */
            addSwitches () {
                let arr = {
                    name: '开关',
                    Type: 'Switches',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            FieldRequired: true,
                            DefaultVal: '',
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增坐标
             */
            addZb () {
                let arr = {
                    name: '坐标',
                    Type: 'Zb',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            XCode: '',
                            YCode: '',
                            ZCode: '',
                            FieldRequired: true,
                            XDefaultVal: '',
                            YDefaultVal: '',
                            ZDefaultVal: '',
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增表格
             */
            addTable () {
                let arr = {
                    name: '表格',
                    Type: 'Table',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            cols: '12',
                            Options: [], // 头部配置
                            DefaultVal: [], // 表格数据
                            btns: ['del', 'add'],
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 新增级联
             */
            addCascader () {
                let arr = {
                    name: '级联选择器',
                    Type: 'Cascader',
                    Fields: [
                        {
                            Label: '',
                            Code: '',
                            Level: 1,
                            FieldRequired: true,
                            DefaultVal: '',
                            Options: [],
                            cols: '12',
                        },
                    ],
                }
                this.items.push(arr)
            },
            /**
             * 级联添加子级
             */
            addSubLevel (item, index) {
                let arr = {
                    Label: '',
                    Code: '',
                    Level: item.Level + 1,
                    FieldRequired: true,
                    DefaultVal: '',
                    Options: [],
                    currOptions: [],
                    cols: '12',
                }
                if (item.Options.length > 0) {
                    this.items[index].Fields.push(arr)
                } else {
                    this.$swal.fire('请先添加配置项', '', 'error')
                }
            },
            /**
             * 换位
             */
            move (item, index, type) {
                if (type === 'down') {
                    this.items.splice(index, 1)
                    this.items.splice(index + 1, 0, item)
                } else if (type === 'up') {
                    this.items.splice(index, 1)
                    this.items.splice(index - 1, 0, item)
                }
            },
            /**
             * 添加配置项
             */
            addOptions (item, index, index2) {
                this.optionsDialog = true
                this.currIndex = index
                this.currIndex2 = index2
                this.myOptionsItems = item
                if (item.Level > 1) {
                    this.parentOptions =
                        this.items[index].Fields[index2 - 1].Options
                }
            },
            /**
             * 添加表格配置项
             */
            addTableOptions (item, index) {
                this.tableOptionsDialog = true
                this.currIndex = index
                this.tableOptionsItems = item.Options
            },
            /**
             * 联动
             */
            changeCascader (item, index, e) {
                if (item.Fields.length - 1 > index) {
                    item.Fields[index + 1].currOptions = item.Fields[
                        index + 1
                    ].Options.filter((item) => {
                        return item.pValue == e
                    })
                }
            },
            /**
             * 保存表格配置项
             */
            saveTableOptions (items) {
                this.items[this.currIndex].Fields[0].Options = items
            },
            /**
             * 保存配置项
             */
            saveOptions (items, type) {
                if (type === 'select') {
                    this.items[this.currIndex].Fields[0].Options = items
                } else {
                    this.items[this.currIndex].Fields[this.currIndex2].Options =
                        items

                    this.items[this.currIndex].Fields[this.currIndex2].currOptions =
                        this.items[this.currIndex].Fields[
                            this.currIndex2
                        ].Options.filter((item) => {
                            return (
                                item.pValue ==
                                this.items[this.currIndex].Fields[
                                    this.currIndex2 - 1
                                ].DefaultVal
                            )
                        })
                }
                this.$nextTick(() => {
                    let options =
                        this.items[this.currIndex].Fields[this.currIndex2].Options
                    this.filterOptions(options, this.currIndex, this.currIndex2)
                })
            },
            // 去除冗余数据
            filterOptions (options, index, index2) {
                if (this.items[index].Fields[index2 + 1]) {
                    let newArray = []
                    options.forEach((item) => {
                        let newMap = this.items[index].Fields[
                            index2 + 1
                        ].Options.filter((m) => {
                            return m.pValue === item.value
                        })
                        newArray.push(...newMap)
                    })
                    this.items[index].Fields[index2 + 1].Options = newArray
                    // 删除相关联的子级
                    this.filterOptions(newArray, index, index2 + 1)
                }
            },
            /**
             * 删除级联相关
             */
            removeSubLevel (index, index2) {
                this.items[index].Fields.splice(index2, 1)
            },
            /**
             * 坐标字段代码相关
             */
            changeZbCode (item, e) {
                if (e) {
                    item.XCode = e + 'X'
                    item.YCode = e + 'Y'
                    item.ZCode = e + 'Z'
                } else {
                    item.XCode = ''
                    item.YCode = ''
                    item.ZCode = ''
                }
            },
            /**
             * 删除
             */
            delFields (index) {
                this.items.splice(index, 1)
            },
            /**
             * 保存
             */
            save () {
                this.$refs.form.validate()
                if (this.valid) {
                    if (this.form._id) {
                        this.form.updater = '测试人2'
                        this.form.config = JSON.stringify(this.items)
                        updateAction(this.form).then((res) => {
                            if (res.code === '200') {
                                this.$swal.fire('修改成功', '', 'success')
                                this.$router.replace({
                                    name: 'Formwork',
                                })
                            }
                        })
                    } else {
                        this.form.creater = '测试人'
                        this.form.updater = '测试人'
                        this.form.config = JSON.stringify(this.items)
                        addAction(this.form).then((res) => {
                            if (res.code === '200') {
                                this.$swal.fire('新增成功', '', 'success')
                                this.$router.replace({
                                    name: 'Formwork',
                                })
                            }
                        })
                    }
                } else {
                    this.$swal.fire('存在必填项未填写', '', 'error')
                }
            },
            /**
             * 返回
             */
            close () {
                this.$router.replace({
                    name: 'action',
                })
            },
            toFormwork () {
                this.$router.push({ path: "./Formwork" });
            },
        },
    }
</script>
<style lang="scss" scoped>
    .optionsBtn {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;

        a {
            color: rgb(0, 179, 255);
            margin-left: 10px;
            text-decoration: none;
        }

        .removeSubLevel {
            color: red;
        }
    }

    .card-content {
        width: 100%;
        min-height: 400px;
    }

    ::v-deep .v-input__append-outer .v-icon.v-icon--link {
        font-size: 24px;
        color: #3e3636;
    }

    .tableCol {
        display: flex;
        flex-wrap: nowrap;
        align-content: space-between;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        width: 100%;
    }

    .v-data-table {
        width: 100%;
    }
</style>